const FREIGHTSIMPLE_URL = "https://www.freightsimple.com";

interface LogoProps {
  /** Where the logo links. Defaults to the FreightSimple marketing site. */
  href?: string;
}

/**
 * The FreightSimple wordmark: the five-square glyph plus "freight" (bold) /
 * "simple" (semibold), linking to the marketing site by default. The glyph is
 * fixed brand blue + gold; the wordmark uses theme text tokens so it stays
 * legible on both light and dark surfaces.
 */
export function Logo({ href = FREIGHTSIMPLE_URL }: LogoProps) {
  // An off-site link (the marketing site) opens in a new tab so it doesn't
  // navigate the app away; an in-app href stays in the same tab.
  const isExternal = href.startsWith("http");
  return (
    <a
      href={href}
      target={isExternal ? "_blank" : undefined}
      rel={isExternal ? "noopener noreferrer" : undefined}
      className="inline-flex items-center gap-[9px] font-['neue-haas-grotesk-display'] no-underline"
    >
      <LogoGlyph_ />
      {/* "freight" and "simple" butt together as one wordmark — no space. */}
      <span className="text-2xl">
        <span className="font-bold text-foreground">freight</span>
        <span className="font-semibold text-content-secondary">simple</span>
      </span>
    </a>
  );
}

function LogoGlyph_() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path fill="#4C62EA" d="M0 0H24V8H0z" />
      <path fill="#4C62EA" d="M0 8H16V16H0z" />
      <path fill="#FACC0B" d="M8 16H24V24H8z" />
      <path fill="#4C62EA" d="M0 16H8V24H0z" />
      <path fill="#FACC0B" d="M16 8H24V16H16z" />
    </svg>
  );
}
